import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { active_category_type } from "./options_modal";
import QuantityEditor from "./quantity_editor";
import IconButton from "./icon_button";
import { Fragment } from "react";
import SelectedOption from "./selected_option";

const SelectedOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  padding: 0px 5px;
  background-color: #F7F7F7;
  border: 1px solid  #CCCCCC;
  border-radius: 4px;
`;

const SelectedOptionsHeader = styled.div`
  display: flex;
  padding: 4px 4px 4px 0px;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    padding: 4px;
  }
`;

const SelectedOptionsTitle = styled.span`
  display: block;
  font-weight: 400;
  font-size: 14px;
  color: #626469;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const MobileSelectedOptionsTitle = styled.span`
  display: none;
  color: #626469;
  font-size: 14px;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: block;
  }
`;

const SelectedOptionsArrowWrapper = styled.div`
  width: 24px;
  height: 24px;
  padding: 4px;
  box-sizing: border-box;
  transform: ${(props) => (props.isOpen ? "rotate(0deg)" : "rotate(-90deg)")};
  transition: transform 250ms;
  display: flex;
  align-items: center;
`;

const SelectedOptionsContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 4px 10px 0px;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    padding: 4px;
  }
`;

const SelectedOptionsCategory = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

const SelectedOptionsTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const SelectedOptionsCategoryTitle = styled.span`
  font-weight: 700;
  font-size: 12px;
  color: #626469;
`;

const AddMore = styled.div`
  font-weight: 400;
  font-size: 14px;
  margin-left: 10px;
  color: ${props => props.color ? props.color : '#42B4E6'};

  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const EditAndDeleteWrapper = styled.div`
  display: flex;
`;


class SelectedOptions extends React.Component {
  static propTypes = {
    renderProductLink: PropTypes.func,
    moduleItem: PropTypes.object,
    isSaving: PropTypes.bool,
    getLabel:PropTypes.func,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secondaryTextColor: PropTypes.string,
    onAddMore: PropTypes.func,
    onViewAccessory: PropTypes.func,
    optionsLoading: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      showOptions: false
    };
  }

  removeItem = (item) => {
    if (item.onRemove) {
      item.onRemove(this.props.moduleItem.deviceIdentification, item.optionIdentification);
    }
  }

  renderQuantity = (item) => {

    return (
      <QuantityEditor
        primaryColor={this.props.primaryColor}
        primaryTextColor={this.props.primaryTextColor}
        isSaving={this.props.isSaving}
        quantity={item.quantity}
        canIncrease={item.canIncrease}
        onIncrease={() => { item.onIncrease(this.props.moduleItem.deviceIdentification, item.optionIdentification, 1); }}
        canDecrease={item.canDecrease}
        onDecrease={() => {
          if (item.quantity === 1) {
            this.removeItem(item);
          } else  {
            item.onDecrease(this.props.moduleItem.deviceIdentification, item.optionIdentification, 1);
          }
        }}>
      </QuantityEditor>);
  }

  renderActionButtons = (item, categoryModalKey) => {
    return (
      <EditAndDeleteWrapper>
        {item.canShowInModal && <IconButton icon="edit" size={40} padding={7} color={this.props.primaryColor} onClick={() => {
          this.props.onViewAccessory(item, categoryModalKey, item.filterStatusOnEdit, item.disablePreviousOnEdit || false);
        }} disabled={this.props.isSaving}></IconButton>}
        {item.canRemove && <IconButton icon="remove" size={40} padding={7} color={'#626469'} onClick={() => {
          this.removeItem(item);
        }} disabled={this.props.isSaving}>
        </IconButton>}
      </EditAndDeleteWrapper>
    );
  }

  renderSelectedOptionsCategory = (category, categoryTitle, nbOptions, categoryModalKey) => {
    return (
      <SelectedOptionsCategory>
        <SelectedOptionsTitleWrapper>
          <SelectedOptionsCategoryTitle>{`${categoryTitle} (${nbOptions})`}</SelectedOptionsCategoryTitle>
          <AddMore id={`${this.props.moduleItem.deviceIdentification.identificationKey}-add-more`} color={this.props.primaryColor} onClick={() => { this.props.onAddMore(categoryModalKey); }}>{this.props.getLabel('options_screen.add_more')}</AddMore>
        </SelectedOptionsTitleWrapper>
        {category.map((item, idx) => {
          return (
            <Fragment key={idx}>
              <SelectedOption
                renderProductLink={this.props.renderProductLink}
                selectedOption={item}
                moduleItem={this.props.moduleItem}
                isSaving={this.props.isSaving}
                getLabel={this.props.getLabel}
                primaryColor={this.props.primaryColor}
                primaryTextColor={this.props.primaryTextColor}
                onViewAccessory={this.props.onViewAccessory}
                categoryModalKey={categoryModalKey}
              >
              </SelectedOption>
            </Fragment>
          );
        })}
      </SelectedOptionsCategory>
    );
  }

  computeCategoryQuantity = (optionsArray) => {
    let result = 0;
    for (const opt of optionsArray) {
      result += opt.quantity;
    }
    return result;
  }
  computeCategoryQuantityForSubAccessories = (accessories) => {
    let result = 0;
    for (const accessory of accessories) {
      if (accessory.subAccessories) {
        for (const subAccessory of accessory.subAccessories) {
          result += subAccessory.quantity;
        }
      }
    }
    return result;
  }

  renderSelectedOptionLabel = (nbSelectedOptions) => {
    if (this.props.optionsLoading) {
      return `${this.props.getLabel('options_screen.selected_options_for_device')} (...)`;
    }
    return `${this.props.getLabel('options_screen.selected_options_for_device')} (${nbSelectedOptions})`;
  }


  renderSelectedOptions = (module) => {
    const nbAccessories = this.computeCategoryQuantity(module.selectedOptions?.accessories || []);
    const nbServices = this.computeCategoryQuantity(module.selectedOptions?.services || []);
    const nbSubAccessories = this.computeCategoryQuantityForSubAccessories(module.selectedOptions?.accessories || []);
    const nbSelectedOptions = nbAccessories + nbServices + nbSubAccessories;

    return (
      <>
        {nbSelectedOptions > 0 && <SelectedOptionsWrapper>
          <SelectedOptionsHeader id={`${module.deviceIdentification.identificationKey}-selectedoptions-header`} mobileBreakpoint={this.props.mobileBreakpoint} onClick={(event) => { event.stopPropagation(); this.setState({showOptions: !this.state.showOptions}); }}>
            <SelectedOptionsTitle mobileBreakpoint={this.props.mobileBreakpoint}>{this.renderSelectedOptionLabel(nbSelectedOptions)}</SelectedOptionsTitle>
            <MobileSelectedOptionsTitle mobileBreakpoint={this.props.mobileBreakpoint}>{this.renderSelectedOptionLabel(nbSelectedOptions)}</MobileSelectedOptionsTitle>
            <SelectedOptionsArrowWrapper mobileBreakpoint={this.props.mobileBreakpoint} isOpen={this.state.showOptions}> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                <path
                  fill="currentColor"
                  d="M134 347.2C126 339.2 126 325.2 134 317.2C138 313.2 144 311.2 149 311.2C155 311.2 160 313.2 164 317.2L510.6 663.5L860 315.5C864 311.5 869 309.5 875 309.5C880 309.5 886 311.5 890 315.5C898 323.5 898 337.5 890 345.5L526.6 708.5C517.6 716.5 504.6 716.5 495.6 708.5L134 347.2Z"
                />
              </svg>
            </SelectedOptionsArrowWrapper>
          </SelectedOptionsHeader>
          {this.state.showOptions && <SelectedOptionsContent mobileBreakpoint={this.props.mobileBreakpoint}>
            {nbAccessories > 0 && this.renderSelectedOptionsCategory(module.selectedOptions?.accessories, this.props.getLabel('options_screen.accessories'), nbAccessories+nbSubAccessories, active_category_type.accessories)}
            {nbServices > 0 && this.renderSelectedOptionsCategory(module.selectedOptions?.services, this.props.getLabel('options_screen.services'), nbServices, active_category_type.services)}
          </SelectedOptionsContent>}
        </SelectedOptionsWrapper>}
      </>
    );
  }
  render() {
    return (this.renderSelectedOptions(this.props.moduleItem));
  }
}

export default SelectedOptions;
